<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :md="4">
          <el-input placeholder="会员账号" v-model="mobile" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="16" :lg="16">
          <el-date-picker v-model="created" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
          <el-button size="mini" type="primary" @click="preview">员工提现预览</el-button>
          <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>
          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表-优选员工提现工资’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
          <el-upload style="display: inline;" action="" :on-change="uploadHandleChange" :auto-upload="false" :show-file-list="false" >
            <el-button size="mini" type="primary">点击上传</el-button>
          </el-upload>
          <a type="primary" href="https://img1.yaoking.cn/000/%E5%91%98%E5%B7%A5%E4%BF%A1%E6%81%AF%E6%A8%A1%E6%9D%BF.xlsx">导入模板下载</a>
          <el-upload
            style="display: inline; margin-left: 8px;"
            action=""
            :on-change="rollbackUploadChange"
            :auto-upload="false"
            :show-file-list="false"
            :disabled="rollbackLoading"
          >
            <el-button size="mini" type="warning" :loading="rollbackLoading">员工佣金回退</el-button>
          </el-upload>
          <el-popover
            placement="top-start"
            width="280"
            trigger="hover"
            content="上传 Excel：首列表头为「订单号」，从第2行起填写 sharer_withdraw 提现单号。执行后将对应记录的审核状态、结算状态置为0，用于离职/休假员工无法走工资发放时回退。订单号列请设置为文本格式。">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>

      <div class="recharge-overview view-flex content-center content-padded" style="width: 40%;">
        <div class="view-flex-item">
          <i class="iconfont icon-donate"></i>
          <div><span>总金额：</span> <span class="money mark">{{amount_total}}</span> 元</div>
        </div>
        <div class="view-flex-item">
          <i class="iconfont icon-credit-card1"></i>
          <div>总条数：<span class="money mark">{{total_count}}</span> 条</div>
        </div>
      </div>
      <el-dialog title="报表下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>
      <el-table :data="withdrawData" :height="wheight-210"  v-loading="loading">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column prop="yg_id" label="员工ID" width="80"></el-table-column>
        <el-table-column prop="mobile"   label="账号" width="120"></el-table-column>
        <el-table-column prop="name"  label="姓名" width="80"></el-table-column>
        <el-table-column prop="money"  label="金额" width="80"></el-table-column>
        <el-table-column prop="manner"  label="打款方式" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.manner=='3'">工资卡</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_id"  label="订单号" width="240"></el-table-column>
        <el-table-column prop="yg_status" label="员工状态" width="100"></el-table-column>
        <el-table-column prop="created_at" label="申请时间" width="180">
          <template slot-scope="scope">
            {{scope.row.created_at | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop="memo"  label="说明" width="260"></el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {
  stafftixianList,
  stafftixianExport,
  handleUploadFile,
  staffCommissionRollback
} from '../../../api/sharer'
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      id: [],
      amount_total: 0,
      total_count: 0,
      loading: false,
      exportLoading: false,
      rollbackLoading: false,
      btnLoading: false,
      withdrawData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      mobile: '',
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    uploadHandleChange (file, fileList) {
      let params = {isUploadFile: true, file: file.raw}
      console.log(params)
      handleUploadFile(params).then(response => {
        if (response.data.data.status) {
          let count = response.data.data.count
          this.$message({
            type: 'success',
            message: '上传成功，本次共新增' + count + '条数据'
          })
        } else {
          this.$message({
            type: 'error',
            message: response.data.data.message
          })
        }
      })
    },
    rollbackUploadChange (file) {
      if (!file || !file.raw) {
        return
      }
      this.$confirm(
        '确认按上传的订单号执行佣金回退？将把对应 sharer_withdraw 记录的审核状态、结算状态置为 0。',
        '佣金回退确认',
        {
          confirmButtonText: '确认回退',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.rollbackLoading = true
        staffCommissionRollback({ isUploadFile: true, file: file.raw })
          .then(response => {
            this.rollbackLoading = false
            const res = (response.data && response.data.data) || {}
            if (res.status) {
              let msg = `回退完成：共上传 ${res.total} 个订单号，成功更新 ${res.affected} 条`
              if (res.not_found_count > 0) {
                msg += `，未找到 ${res.not_found_count} 条`
              }
              this.$message({
                type: res.not_found_count > 0 ? 'warning' : 'success',
                message: msg,
                duration: 5000
              })
              if (res.not_found && res.not_found.length > 0 && res.not_found.length <= 20) {
                this.$alert(res.not_found.join('<br/>'), '未找到的订单号', {
                  dangerouslyUseHTMLString: true
                })
              }
            } else {
              this.$message.error(res.message || '佣金回退失败')
            }
          })
          .catch((err) => {
            this.rollbackLoading = false
            const msg = (err && err.response && err.response.data && err.response.data.message) || '佣金回退失败，请重试'
            this.$message.error(msg)
          })
      }).catch(() => {})
    },
    getStafftixianList (filter) {
      this.loading = true
      stafftixianList(filter).then(response => {
        this.withdrawData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.amount_total = response.data.data.amount_total
        this.loading = false
        this.exportLoading = false
      })
    },
    getParams () {
      this.params.mobile = this.mobile
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      this.getStafftixianList(this.params)
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    preview() {
      this.params.page = 1
      this.params.tongbu_status = '0'
      this.getStafftixianList(this.params)
    },
    keywordsSearch (e) {
      this.params.page = 1
      this.getParams()
      this.getStafftixianList(this.params)
    },
    exportData () {
      this.getParams()
      this.exportLoading = true
      stafftixianExport(this.params).then(response => {
        this.exportLoading = false
        if (response.data.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表-优选员工提现工资中下载'
          })
          return
        } else if (response.data.data.url) {
          this.downloadUrl = response.data.data.url
          this.downloadName = response.data.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      })
    },
    handleCancelLabelsDialog2 () {
      this.editInfoDialog2 = false
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getStafftixianList(this.params)
    }
  },
  mounted () {
    this.getStafftixianList(this.params)
  },
  watch: {
    withdrawData: {
      handler (value) {
        if (this.allCheck) {
          this.withdrawData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
.mobile-editor {
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
}
.recharge-overview {
  .iconfont {
    font-size: 30px;
    color: #ff5000;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?0df78311